"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileBestOffers = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _SubCategory = require("../CategoryContent/SubCategory");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MobileBestOffers = ({
  content
}) => {
  const [activeSubCategory, setActiveSubCategory] = (0, _react.useState)('');
  const handleSubCategoryClick = (0, _react.useCallback)(subCategory => {
    if (subCategory === activeSubCategory) {
      setActiveSubCategory('');
    } else {
      setActiveSubCategory(subCategory);
    }
  }, [activeSubCategory]);
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const itemsList = (0, _react.useMemo)(() => content?.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubCategory.SubCategory, {
    boldText: true,
    isBestOffers: true,
    subCategory: item,
    displayArrowIcon: item.children.length > 0,
    activeSubCategory: activeSubCategory,
    handleSubCategoryClick: handleSubCategoryClick
  }, item.id)), [content, activeSubCategory, handleSubCategoryClick]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MobileRoot, {
    "data-testid": getTestId(_constants.BEST_OFFERS_SUBMENU_MOBILE),
    children: itemsList
  });
};
exports.MobileBestOffers = MobileBestOffers;